import template from './organizationGroupsAndBranchesMove.template.html';

export default {
  bindings: {
    groupsAndBranches: '=',
    onFinished: '&'
  },
  controller: class controller {
    constructor(
      $mdDialog,
      $mdMedia,
      $filter,
      $timeout,
      $rootScope,
      eventService,
      organizationService,
      uiService,
      Organization,
      INSTANCE
    ) {
      'ngInject';
      /*
       * Controller Model
       * --------------------------------------------------------------------------------
       */
      var ctrl = this;
      ctrl.$mdDialog = $mdDialog;
      ctrl.$mdMedia = $mdMedia;
      ctrl.destroyWatch = null;

      /*
       * Methods
       * --------------------------------------------------------------------------------
       */
      this.initialize = function () {
        ctrl.destroyWatch = eventService.onGroupsAndBranchesMove(function (_params) {
          $mdDialog
            .show({
              targetEvent: _params.event,
              locals: {
                groupsAndBranches: ctrl.groupsAndBranches,
                organization: _params.organization
              },
              template,
              controllerAs: '$ctrl',
              controller: dialogController
            })
            .then(function (organization) {
              const idParentOriginal = _params.organization.idParent;
              if (idParentOriginal !== organization.idParent) {
                const org = new Organization(organization);
                uiService.toast({
                  text: {
                    p1: 'Organization ' + org.getName(),
                    p2: 'is being moved',
                    p3: 'please wait'
                  },
                  progress: true,
                  warn: true
                });
                organizationService
                  .moveGoB({ idOrganization: organization.id, idParent: organization.idParent })
                  .then((data) => {
                    if (data.status) {
                      ctrl.onFinished({ organizationGaB: organization });
                      uiService.toast({
                        text: {
                          p1: 'Organization',
                          p2: org.getName(),
                          p3: 'has been moved'
                        }
                      });
                    }
                  });
              }
            });

          function dialogController(
            $scope,
            $mdDialog,
            $rootScope,
            INSTANCE,
            groupsAndBranches,
            organization
          ) {
            this.INSTANCE = INSTANCE;
            this.IsEnterprise = $rootScope.IsEnterprise;
            this.availableGroups = _.filter(groupsAndBranches, (org) => {
              return org.isGroup();
            });
            this.organization = new Organization(organization);
            this.isGroup = this.organization.isGroup();
            this.isBranch = this.organization.isBranch();
            var self = this;
            this.confirm = () => {
              $mdDialog.hide(this.organization);
            };
            this.cancel = () => {
              $mdDialog.cancel();
            };
          }
        });
      };

      /*
       * Execute when all bindings are completed
       * --------------------------------------------------------------------------------
       */
      this.$onInit = function () {
        ctrl.initialize();
      };

      /*
       * Execute when bindings change
       * --------------------------------------------------------------------------------
       */
      this.$onChanges = function (changes) {
        if (changes.groupsAndBranches && changes.groupsAndBranches.currentValue) {
          ctrl.initialize();
        }
      };

      /*
       * Execute when component is not necessary anymore
       * --------------------------------------------------------------------------------
       */
      this.$onDestroy = function () {
        ctrl.destroyWatch();
      };
    }
  }
};
